import { nfeStatusEnum } from '../enums';
import api from '../../../../../configurations/service';
import * as types from './mutation-types';
import { MODELO } from '../../../enums/Documento';

const { NFCE, SAT } = MODELO;

export const setNfeCollection = async (context, params) => {
  const search = params.search ?? '';
  const modelos = params.modelos ?? [MODELO.NFE];
  const statusTransmissao = params.statusTransmissao ?? nfeStatusEnum.AUTHORIZED;

  const body = { maxResults: 10, search, modelos, statusTransmissao };
  const { data } = await api().post('fiscal.get-nfe', body);
  context.commit(types.SET_NFE_COLLECTION, data);
};

export const setPreValidationNfe = async (context, modelo = null) => {
  const body = { modelos: [NFCE, SAT] };
  if (modelo !== null) {
    body.modelos = [modelo];
  }
  const { data } = await api().post('fiscal.get-pre-validation-nfe', body);
  context.commit(types.SET_PRE_VALIDATION_NFE, data);
};

export const putXML = async (context, id) => {
  const { data } = await api().post('fiscal.put-xml', { id });
  return data;
};
